import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { css } from 'styled-components'

import {
  Checkbox,
  Divider,
  DropdownItem,
  FilterContext,
  FormInput,
  Icon,
  Loading,
  Typography,
  debounce,
  getFiltersByFilterDef,
} from '../'
import { FilterDef, FilterOption, SelectManyFilterDef } from './types'

function SelectManyFilter({
  filterDef,
  onChange,
  searchOptions,
  searchOptionsLoading,
  onSearch,
}: {
  filterDef: SelectManyFilterDef
  onChange?: () => void
  searchOptions?: FilterOption[]
  searchOptionsLoading?: boolean
  onSearch?: (val: string) => void
}) {
  const { control, watch } = useFormContext()
  const filterContext = React.useContext(FilterContext)
  const [selectedSearchOptions, setSelectedSearchOptions] = React.useState<
    FilterOption[]
  >([])

  const handleChanged = (callback: () => void) => {
    // istanbul ignore next
    debounce(callback, 400)()
  }

  const onSelect = filterDef.onSelect

  const filterValues = watch()

  return (
    <div css='padding-inline: 5px;'>
      {!!filterDef.searchable && (
        <div
          css={css`
            padding: 5px 15px;
          `}
        >
          <FormInput
            aria-label='search filter'
            leftAdornment={<Icon size='small' type='SEARCH' />}
            placeholder='Search...'
            size='small'
            rightAdornment={
              searchOptionsLoading ? (
                <Loading
                  style={{ top: 'auto', left: '-5px', paddingRight: '10px' }}
                  size='xsmall'
                />
              ) : null
            }
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              // istanbul ignore next
              e.preventDefault()

              handleChanged(() => {
                onSearch?.(e.target.value)

                filterContext?.resetField({
                  filterDef: filterDef as FilterDef,
                  fields: filterValues,
                })
              })
            }}
          />
        </div>
      )}
      {/* {searchOptionsLoading && (
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 20px 0;
          `}
        >
          <Loading size='xsmall' />
        </div>
      )} */}
      {(searchOptions ?? filterDef.options).map((option, i) => {
        return (
          <Controller
            key={`${filterDef.key}-${option.value}`}
            name={`${filterDef.key}-${i}`}
            control={control}
            render={({ field }) => {
              return (
                <DropdownItem as='div' className='select-many-dropdown-item'>
                  <Checkbox
                    style={{ width: '100%' }}
                    checked={!!field.value}
                    onCheck={(checked) => {
                      const values = watch()
                      const valuesAsArray =
                        Object.values(values).filter(Boolean)

                      if (onSelect) {
                        const disabled = onSelect(option.value, valuesAsArray)
                        if (disabled) return
                      }

                      field.onChange(checked ? option.value : '')

                      if (onChange) onChange()
                    }}
                  >
                    <span
                      css={css`
                          display: flex;
                          justify-content: space-between;
                      `}
                    >
                      <span
                        css={css`
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            padding-right: 10px;
                      `}
                      >
                        {option.label}
                      </span>
                      <Typography
                        variant='body'
                        css={css`
                        text-overflow: clip;
                        padding-bottom: 2px;
                        `}
                      >
                        {option.count}
                      </Typography>
                    </span>
                  </Checkbox>
                </DropdownItem>
              )
            }}
          />
        )
      })}
    </div>
  )
}

export default SelectManyFilter
